import { render } from "./twoFaActivationPopup.vue?vue&type=template&id=ad20058c&scoped=true"
import script from "./twoFaActivationPopup.vue?vue&type=script&lang=js"
export * from "./twoFaActivationPopup.vue?vue&type=script&lang=js"

import "../less/twoFaPopup.less?vue&type=style&index=0&id=ad20058c&scoped=true&lang=css&external"
import "./twoFaActivationPopup.vue?vue&type=style&index=1&id=ad20058c&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad20058c"]])

export default __exports__